import React from "react";
import FilterList from "../../../components/adm/form/formFilterList";
import Layout from "../../../components/layouts/verticalLayout";

const FormListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

FormListPage.propTypes = {};

export default FormListPage;
